/* eslint-disable no-var */
/* eslint-disable no-unused-vars */
import { Modal, Row, Col } from 'react-bootstrap';
import docImage from '../../../assets/images/svg/doc.svg';
import { SimpleTag } from '../../tags';
import { SimpleCard } from '../../Card';
import CustomSelect2 from '../../customSelect2/CustomSelect2';
import {
  HeadingDesc,
  HeadingDescSmall,
  HeadingDescVsmall,
  HeadingWithSpaceLarge
} from '../../Headings';
import closeIcon from '../../../assets/images/svg/modal-close.svg';
// import CustomCalender from '../../customCalender/CustomCalender';
import CustomInput from '../../customInput/CustomInput';
import { DateInputs } from '../../inputs';
import './addPatientModal.css';
import { SimpleAncerSmall } from '../../button';

const patientGender = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' }
];

function AddPatientModal(props) {
  const { show, close, onClick } = props;

  return (
    <Modal
      show={show}
      className="modalLayout addPatientModal"
      onHide={close}
      centered
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Body>
        <div className="content">
          <button type="button" className="modalCloseBtn" onClick={close}>
            <img src={closeIcon} alt="closeIcon" />
          </button>
          <Row>
            <Col md={6}>
              <div className="inputBox">
                <HeadingDescVsmall text="Patient’s Full Name*" />
                <CustomInput type="text" />
              </div>
            </Col>
            <Col md={6}>
              <div className="inputBox">
                <HeadingDescVsmall text="Patient’s Phone Number*" />
                <div className="phone_detail">
                  <div className="input_box">
                    <span>+92 </span>
                    <input
                      placeholder=""
                      className="custom_input"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="inputBox">
                <HeadingDescVsmall text="Email Address" />
                <CustomInput type="email" />
              </div>
            </Col>
            <Col md={6}>
              <div className="inputBox">
                <HeadingDescVsmall text="Relatioship*" />
                <CustomInput type="text" />
              </div>
            </Col>
            <Col md={6}>
              <div className="inputBox">
                <HeadingDescVsmall text="Patient’s Date of Birth" />
                <DateInputs />
              </div>
            </Col>
            <Col md={6}>
              <div className="inputBox">
                <HeadingDescVsmall text="Phone number where the doctor can reach you*" />
                <CustomSelect2 options={patientGender} placeholder="" />
              </div>
            </Col>
            <Col md={6}>
              <SimpleAncerSmall text="CONTINUE" />
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AddPatientModal;
